import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierCybilleController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierCybilleController.php
* @route '/api/partners/fetch-cybille/{dossier}'
*/
const FetchDossierCybilleControllerc356fdc0db9be71ebbf82e6b499a5a49 = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchDossierCybilleControllerc356fdc0db9be71ebbf82e6b499a5a49.url(args, options),
    method: 'post',
})

FetchDossierCybilleControllerc356fdc0db9be71ebbf82e6b499a5a49.definition = {
    methods: ["post"],
    url: '/api/partners/fetch-cybille/{dossier}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierCybilleController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierCybilleController.php
* @route '/api/partners/fetch-cybille/{dossier}'
*/
FetchDossierCybilleControllerc356fdc0db9be71ebbf82e6b499a5a49.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchDossierCybilleControllerc356fdc0db9be71ebbf82e6b499a5a49.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierCybilleController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierCybilleController.php
* @route '/api/partners/fetch-cybille/{dossier}'
*/
FetchDossierCybilleControllerc356fdc0db9be71ebbf82e6b499a5a49.post = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchDossierCybilleControllerc356fdc0db9be71ebbf82e6b499a5a49.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierCybilleController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierCybilleController.php
* @route '/api/dossier/{dossier}/cybille'
*/
const FetchDossierCybilleController33909073c74a5662d505ef3284ea053f = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierCybilleController33909073c74a5662d505ef3284ea053f.url(args, options),
    method: 'get',
})

FetchDossierCybilleController33909073c74a5662d505ef3284ea053f.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/cybille',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierCybilleController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierCybilleController.php
* @route '/api/dossier/{dossier}/cybille'
*/
FetchDossierCybilleController33909073c74a5662d505ef3284ea053f.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchDossierCybilleController33909073c74a5662d505ef3284ea053f.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierCybilleController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierCybilleController.php
* @route '/api/dossier/{dossier}/cybille'
*/
FetchDossierCybilleController33909073c74a5662d505ef3284ea053f.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierCybilleController33909073c74a5662d505ef3284ea053f.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierCybilleController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierCybilleController.php
* @route '/api/dossier/{dossier}/cybille'
*/
FetchDossierCybilleController33909073c74a5662d505ef3284ea053f.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchDossierCybilleController33909073c74a5662d505ef3284ea053f.url(args, options),
    method: 'head',
})

/**
* Multiple routes resolve to \App\Http\Controllers\Dossier\Partners\FetchDossierCybilleController::FetchDossierCybilleController, so this export is a
* dictionary keyed by URI rather than a callable, with the verbs prefixed where two routes share a URI.
* Call a specific route with `FetchDossierCybilleController['<key>'](...)`, or import the route by name from your
* generated `routes/` directory.
*/
const FetchDossierCybilleController = {
    '/api/partners/fetch-cybille/{dossier}': FetchDossierCybilleControllerc356fdc0db9be71ebbf82e6b499a5a49,
    '/api/dossier/{dossier}/cybille': FetchDossierCybilleController33909073c74a5662d505ef3284ea053f,
}

export default FetchDossierCybilleController